import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const dashboardLoginGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const email = localStorage.getItem('accessTokenE');
  const password = localStorage.getItem('accessTokenP');

  if (email === 'GenAISuperAdmin' && password === 'GenAI@123321') {
    return true;
  }

  const lang = state.url.split('/')[1] || 'en';
  router.navigate([`/${lang}/admin/login`]);
  return false;
};
